import React from 'react';
import PropTypes from 'prop-types';

import { UiBlocker as UiBlockerBase } from '@bingads-webui-react/ui-blocker';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getUiBlockerStyles } from '../styles';

export const UiBlocker = ({
  loadingText,
  blocking,
  children,
}) => {
  useDefaultStyles(getUiBlockerStyles);

  return (
    <UiBlockerBase
      blocking={blocking}
      loadingText={loadingText}
      classes={{
        blockUiContainer: 'blocker-global',
        blockerIndicator: 'blocker-indicator',
      }}
    >
      {children}
    </UiBlockerBase>
  );
};

UiBlocker.propTypes = {
  loadingText: PropTypes.string.isRequired,
  blocking: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};
